import { render, staticRenderFns } from "./EditEtymology.vue?vue&type=template&id=fa7161a8&scoped=true&"
import script from "./EditEtymology.vue?vue&type=script&lang=js&"
export * from "./EditEtymology.vue?vue&type=script&lang=js&"
import style0 from "./EditEtymology.vue?vue&type=style&index=0&id=fa7161a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7161a8",
  null
  
)

export default component.exports